export const getWhatsappShareLink = (link: string): string => {
  const url = new URL("https://wa.me/");
  url.searchParams.append("text", link);
  return url.toString();
};
